import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';


const routes: Routes = [
  { path: 'login', loadChildren: () => import('../pages/auth/auth.module').then(m => m.AuthModule) },
  { path: 'change-password', loadChildren: () => import('../pages/change-password/change-password.module').then(m => m.ChangePasswordModule) },
  { path: 'app', loadChildren: () => import('../pages/shell/shell.module').then(m => m.ShellModule), canActivate: [AuthGuard] },

  { path: '', redirectTo: 'app', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'corrected' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
